// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"53":"webfontloader","594":"about"}[chunkId] + "." + {"53":"a407f198","594":"a4cfc25f"}[chunkId] + ".js";
};